module.exports = __webpack_public_path__ + "media/images/partners/airtel-b3e17705a60e9e8e9bb0c9621d7a32a0.jpeg";